<template>
  <div>
    <header-all-areas
      :user="user"
      :ppa="ppa"
    />
    <div class="header-spacer" />
    <div class="container">
      <div
        id="posts-grid-1"
        class="row sorting-container"
        data-layout="masonry"
      >
        <div class="col col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 sorting-item">
          <div class="ui-block">
            <!-- Post -->

            <article class="hentry blog-post blog-post-v1">
              <div class="post-thumb">
                <img
                  loading="lazy"
                  :src="all"
                  alt="photo"
                  width="370"
                  height="261"
                >

                <div class="post-content">
                  <router-link
                    :to="{ path: '/all/articles'}"
                    class="post-category bg-blue-light"
                  >
                    All
                  </router-link>
                  <router-link
                    :to="{ path: '/all/articles'}"
                    class="h4 post-title"
                  >
                    Here's all the things related to your all Areas!
                  </router-link>
                </div>
              </div>
            </article>

            <!-- ... end Post -->
          </div>
        </div>
        <div class="col col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 sorting-item">
          <div class="ui-block">
            <!-- Post -->

            <article class="hentry blog-post blog-post-v1">
              <div class="post-thumb">
                <img
                  loading="lazy"
                  :src="financial"
                  alt="photo"
                  width="368"
                  height="560"
                >

                <div class="post-content">
                  <router-link
                    :to="{ path: `/fin/month/${currentMonth}/${currentYear}`}"
                    class="post-category bg-blue-light"
                  >
                    FIN
                  </router-link>
                  <router-link
                    :to="{ path: `/fin/month/${currentMonth}/${currentYear}`}"
                    class="h4 post-title"
                  >
                    Here's all the things related to FIN area!
                  </router-link>
                </div>
              </div>
            </article>

            <!-- ... end Post -->
          </div>
        </div>
        <div class="col col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 sorting-item">
          <div class="ui-block">
            <!-- Post -->

            <article class="hentry blog-post blog-post-v1">
              <div class="post-thumb">
                <img
                  loading="lazy"
                  :src="vocational"
                  alt="photo"
                  width="370"
                  height="261"
                >

                <div class="post-content">
                  <router-link
                    :to="{ path: '/voc/books'}"
                    class="post-category bg-blue-light"
                  >
                    VOC
                  </router-link>
                  <router-link
                    :to="{ path: '/voc/books'}"
                    class="h4 post-title"
                  >
                    Here's all the things related to VOC area!
                  </router-link>
                </div>
              </div>
            </article>

            <!-- ... end Post -->
          </div>
        </div>
        <div class="col col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 sorting-item">
          <div class="ui-block">
            <!-- Post -->

            <article class="hentry blog-post blog-post-v1">
              <div class="post-thumb">
                <img
                  loading="lazy"
                  :src="mental"
                  alt="photo"
                  width="368"
                  height="501"
                >

                <div class="post-content">
                  <router-link
                    :to="{ path: '/men/method/1'}"
                    class="post-category bg-blue-light"
                  >
                    MEN
                  </router-link>
                  <router-link
                    :to="{ path: '/men/method/1'}"
                    class="h4 post-title"
                  >
                    Here's all the things related to MEN area!
                  </router-link>
                </div>
              </div>
            </article>

            <!-- ... end Post -->
          </div>
        </div>
        <div class="col col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 sorting-item">
          <div class="ui-block">
            <!-- Post -->

            <article class="hentry blog-post blog-post-v1">
              <div class="post-thumb">
                <img
                  loading="lazy"
                  :src="physical"
                  alt="photo"
                  width="369"
                  height="261"
                >

                <div class="post-content">
                  <router-link
                    :to="{ path: '/phy/health'}"
                    class="post-category bg-blue-light"
                  >
                    PHY
                  </router-link>
                  <router-link
                    :to="{ path: '/phy/health'}"
                    class="h4 post-title"
                  >
                    Here's all the things related to PHY area!
                  </router-link>
                </div>
              </div>
            </article>

            <!-- ... end Post -->
          </div>
        </div>
        <div class="col col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 sorting-item">
          <div class="ui-block">
            <!-- Post -->

            <article class="hentry blog-post blog-post-v1">
              <div class="post-thumb">
                <img
                  loading="lazy"
                  :src="social"
                  alt="photo"
                  width="369"
                  height="259"
                >

                <div class="post-content">
                  <router-link
                    :to="{ path: '/soc/chat'}"
                    class="post-category bg-blue-light"
                  >
                    SOC
                  </router-link>
                  <router-link
                    :to="{ path: '/soc/chat'}"
                    class="h4 post-title"
                  >
                    Here's all the things related to SOC area!
                  </router-link>
                </div>
              </div>
            </article>

            <!-- ... end Post -->
          </div>
        </div>
        <div class="col col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 sorting-item">
          <div class="ui-block">
            <!-- Post -->

            <article class="hentry blog-post blog-post-v1">
              <div class="post-thumb">
                <img
                  loading="lazy"
                  :src="familial"
                  alt="photo"
                  width="368"
                  height="520"
                >

                <div class="post-content">
                  <a
                    href="#"
                    class="post-category bg-purple"
                  >FAM</a>
                  <a
                    href="#"
                    class="h4 post-title"
                  >Here's all the things related to FAM area!</a>
                </div>
              </div>
            </article>

            <!-- ... end Post -->
          </div>
        </div>
        <div class="col col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 sorting-item">
          <div class="ui-block">
            <!-- Post -->

            <article class="hentry blog-post blog-post-v1">
              <div class="post-thumb">
                <img
                  loading="lazy"
                  :src="spiritual"
                  alt="photo"
                  width="367"
                  height="261"
                >

                <div class="post-content">
                  <router-link
                    :to="{ path: '/spi/afteridie'}"
                    class="post-category bg-blue-light"
                  >
                    SPI
                  </router-link>
                  <router-link
                    :to="{ path: '/spi/afteridie'}"
                    class="h4 post-title"
                  >
                    Here's all the things related to SPI area!
                  </router-link>
                </div>
              </div>
            </article>

            <!-- ... end Post -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns'
import { mapState } from 'vuex'
import HeaderAllAreas from '../../components/common-apps/common/HeaderAllAreas'
import all from '../../../static/img/areas/all.png'
import familial from '../../../static/img/areas/familial.png'
import spiritual from '../../../static/img/areas/spiritual.png'
import mental from '../../../static/img/areas/mental.png'
import financial from '../../../static/img/areas/financial.png'
import vocational from '../../../static/img/areas/vocational.png'
import social from '../../../static/img/areas/social.png'
import physical from '../../../static/img/areas/physical.png'


export default {
  name: 'Area',
  components: {
    HeaderAllAreas
  },
  data () {
    return {
      all: all,
      familial: familial,
      financial: financial,
      social: social,
      mental: mental,
      vocational: vocational,
      physical: physical,
      spiritual: spiritual,
      currentMonth: format(new Date(),'LL'),
      currentYear: format(new Date(),'yyyy')
    }
  },
  computed: mapState({
    ppa: state => state.account.ppa,
    user () {
      return !this.$store.getters['account/user'] ? { username: 'None' } : this.$store.getters['account/user']
    }
  }),
  mounted() {
    document.body.classList.add('month-page')
  },
  destroyed () {
    document.body.classList.remove('month-page')
  },
  created () {
    this.$store.dispatch('account/fetchUser')
  }
}
</script>

<style lang="scss">
// Bootstrap from node_modules has container smaller
@import '../../scss/Bootstrap/scss/bootstrap-reboot';
@import '../../scss/Bootstrap/scss/bootstrap';
@import '../../scss/Bootstrap/scss/bootstrap-grid';

@import '../../scss/month';
// @import '../../scss/fonts';

</style>
